import axios from 'axios';

const api = axios.create({
  baseURL: '/api/m',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('pm_last_activity');
      // Fire a soft event — AuthContext listens and clears state.
      // This avoids window.location.href (hard redirect) which breaks
      // browser history and causes the back-button logout bug.
      window.dispatchEvent(new Event('auth:logout'));
    }
    return Promise.reject(err);
  }
);

export default api;
